import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-arrow-right",
  "use": "icon-ic-arrow-right-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-ic-arrow-right\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.896 15.893a.833.833 0 0 1 0-1.179L12.61 10 7.896 5.286a.833.833 0 1 1 1.178-1.179l5.303 5.304a.833.833 0 0 1 0 1.178l-5.303 5.304a.833.833 0 0 1-1.178 0Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol